import React, { Component } from 'react'
import T from 'i18n-react'
import CSSModules from 'react-css-modules'
import { branch, renderNothing } from 'recompose'
import { isNil } from 'ramda'

import { getMonthDayYear } from 'helpers/DateUtil'
import SpecItem from 'components/custom/SpecItem/index'
import { hideSpecItem } from 'helpers/specHelpers'
import {
  SCHEDULE_FILTER,
} from 'containers/Project/ScheduleSection/constants'

import styles from './styles.scss'
import { FILTER_ALL } from 'containers/Project/Specifications/constants'

class ScheduleSpec extends Component {
  renderSchedule() {
    const {
      segment,
      moduleData,
      isModifiedPage
    } = this.props
    const scheduleObj = SCHEDULE_FILTER.find(({segment : s}) => s === segment)
    if (!scheduleObj) return

    return scheduleObj.schedules.map((scheduleType, index) => {
      const propertyData = moduleData[scheduleType]
      if (isNil(propertyData)) return

      const {
        date,
        enabled
      } = propertyData

      if (!enabled) return

      return (
        <SpecItem
          key={index}
          label={T.translate('project.schedule.elements.' + scheduleType)}
          initValue=''
          modifiedValue={date ? getMonthDayYear(new Date(date)) : T.translate('project.schedule.scheduleEmpty')}
          isModifiedPage={isModifiedPage}
          hideIcon={true}
          curFilter={FILTER_ALL}
        />
      )
    })
    // filter null values
    .filter(val => val)
  }

  render() {
    const { ModuleHeader } = this.props
    const items = this.renderSchedule()
    const Header = branch(
      () => items.length <= 0,
      renderNothing
    )(ModuleHeader)

    return (
      <div>
        <div styleName='specItemSchedule'>
          { items }
        </div>
      </div>
    )
  }
}

export default CSSModules(ScheduleSpec, styles)
